module.exports = __webpack_public_path__ + "images/e31fc4cf76436f4d583d517df83bede2-kitchen_timber.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/kitchen_timber.jpg
// module id = ./src/assets/images/content/kitchen_timber.jpg
// module chunks = 0